import { v4 as uuidv4 } from 'uuid';
import { ModelDTO } from '../api/useModelGroupsQuery';
import { TEMP_PREFIX } from '../Models.constants';

export const makeNewModel = ({ riskRangeFrom = 1, riskRangeTo = 100 } = {}): ModelDTO => ({
  id: `${TEMP_PREFIX}${uuidv4()}`,
  orionModelId: null,
  portfolioName: '',
  riskRange: {
    from: riskRangeFrom,
    to: riskRangeTo,
  },
  riskScore: null,
  portfolioDescription: '',
  assetAllocationInputModel: [],
  hypotheticalReturn: null,
});
